module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/060-benin-ec195d1e2e6fa1e9e454f90824f1b3f0.svg";